/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import RecipeTags from './recipe-tags';
import RecipeTagsDetail from './recipe-tags-detail';
import RecipeTagsUpdate from './recipe-tags-update';
import RecipeTagsDeleteDialog from './recipe-tags-delete-dialog';

const RecipeTagsRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<RecipeTags />} />
    <Route path="new" element={<RecipeTagsUpdate />} />
    <Route path=":id">
      <Route index element={<RecipeTagsDetail />} />
      <Route path="edit" element={<RecipeTagsUpdate />} />
      <Route path="delete" element={<RecipeTagsDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default RecipeTagsRoutes;
